/**
 * Channel name constants for the cross-feature event bus exposed at
 * `window.ShaunIslands.events`. Legacy code dispatches these on mutation;
 * islands subscribe and re-fetch.
 *
 * Add a new constant when a new feature gains an island. The string values
 * are part of the public bridge contract — never rename without updating
 * every legacy `dispatchEvent` callsite.
 */

export const ACCOUNTS_CHANGED = 'accounts:changed'
export const CONTACTS_CHANGED = 'contacts:changed'
export const STATS_INVALIDATE = 'stats:invalidate'
export const ACTIVITY_CHANGED = 'activity:changed'
export const DEALS_CHANGED = 'deals:changed'

export type IslandEventName =
  | typeof ACCOUNTS_CHANGED
  | typeof CONTACTS_CHANGED
  | typeof STATS_INVALIDATE
  | typeof ACTIVITY_CHANGED
  | typeof DEALS_CHANGED
